export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название', trigger: 'blur' },
    ],
    id_code: [
        { required: true, message: 'Пожалуйста, введите ID код', trigger: 'blur' },
    ],
};